import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldDateRanger,
  FieldInput,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectCollector, FieldSelectDriver } from 'shared-pages';
import { useRootStore } from 'store';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ qrCode: likeObj }, { binSerialNo: likeObj }],
      };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'declaredDate'),
      };
    }
    if (values.collectionPointId) {
      where = { ...where, collectionPointId: values.collectionPointId };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldDateRanger as={FormCol} label="Δήλωση από" name="startDate" name2="endDate" />
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (qr, αριθμό)')}
          type="search"
          disable={disable}
        />
      </Row>
    </FormFilterCard>
  );
};

